import { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  getDocs,
  query,
  where,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { showCustomToast } from "./CustomToast";
import { Button, Paper, Stack, Typography, IconButton, Chip } from "@mui/material";
import { limit } from "firebase/firestore";
import {
  getAuth,
  getAuth as getAuthMobile,
  signInWithCustomToken,
} from "firebase/auth";
import { addMobileVideoLink, deleteMobileVideoLink, updateMobileVideoOrder, addMobileAudioLink, deleteMobileAudioLink, updateMobileVideoLink, updateMobileAudioLink } from "../../api/mobileApi";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { deleteObject } from "firebase/storage";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MovieIcon from "@mui/icons-material/Movie";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import EditIcon from "@mui/icons-material/Edit";

import Skeleton from "@mui/material/Skeleton";
import mobileApp, { mobileStorage } from "../../firebaseMobile";
import MeditationVideosSection from "./MAVideoSections/MeditationVideosSection";
import ReflectionVideosSection from "./MAVideoSections/ReflectionVideosSection";
import ScienceVideosSection from "./MAVideoSections/ScienceVideosSection";
import RetreatDayVideosSection from "./MAVideoSections/RetreatDayVideosSection";
import SimplyStillSections from "./MAVideoSections/SimplyStillSections";
import AddVideoDialog from "./MAVideoDialogs/AddVideoDialog";
import ScienceVideoDialog from "./MAVideoDialogs/ScienceVideoDialog";
import AddAudioDialog from "./MAVideoDialogs/AddAudioDialog";
import EditVideoDialog from "./MAVideoDialogs/EditVideoDialog";
import EditScienceDialog from "./MAVideoDialogs/EditScienceDialog";
import ConfirmDeleteDialog from "./MAVideoDialogs/ConfirmDeleteDialog";

function MAVideoLinks() {
  // listes
  const [meditationVideos, setMeditationVideos] = useState([]);
  const [reflectionVideos, setReflectionVideos] = useState([]);
  const [retreatDay1Videos, setRetreatDay1Videos] = useState([]);
  const [retreatDay2Videos, setRetreatDay2Videos] = useState([]);
  const [retreatDay3Videos, setRetreatDay3Videos] = useState([]);
  const [simplyStillAngerVideos, setSimplyStillAngerVideos] = useState([]);
  const [simplyStillAnxietyVideos, setSimplyStillAnxietyVideos] = useState([]);
  const [simplyStillGroundingVideos, setSimplyStillGroundingVideos] = useState([]);
  const [simplyStillMorningVideos, setSimplyStillMorningVideos] = useState([]);
  const [simplyStillSadnessVideos, setSimplyStillSadnessVideos] = useState([]);
  const [simplyStillSleepVideos, setSimplyStillSleepVideos] = useState([]);
  const [simplyStillStressVideos, setSimplyStillStressVideos] = useState([]);
  const [, setLoadingAddMeditation] = useState(false);
  const [, setLoadingAddReflection] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmTarget, setConfirmTarget] = useState(null); // { id, mobileId, ... }
  const [deleting, setDeleting] = useState(false);
  const authWeb = getAuth();
  const [, setAudioUploading] = useState(false);
  const [addAudioUploading, setAddAudioUploading] = useState(false);
  const [, setAudioProgress] = useState(0);
  const [addAudioProgress, setAddAudioProgress] = useState(0);
  const [editAudioUploading] = useState(false);
  const [editAudioProgress] = useState(0);
  const [audioItems, setAudioItems] = useState([]);
  const [loadingAudios, setLoadingAudios] = useState(true);
  const [addVideoOpen, setAddVideoOpen] = useState(false);
  const [addScienceVideoOpen, setAddScienceVideoOpen] = useState(false);
  const [addAudioOpen, setAddAudioOpen] = useState(false);
  const [addVideoValues, setAddVideoValues] = useState({
    title: "",
    url: "",
    file: null,
    workbookFile: null,
  });
  const [addAudioValues, setAddAudioValues] = useState({
    title: "",
    description: "",
    category: "reflection",
    file: null,
  });
  const [addingVideo, setAddingVideo] = useState(false);
  const [addingAudio, setAddingAudio] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editScienceOpen, setEditScienceOpen] = useState(false);
  const [editTarget, setEditTarget] = useState(null); // { ...docData, id, _kind: 'video'|'audio' }
  const [editValues, setEditValues] = useState({
    title: "",
    description: "",
    url: "", // pour vid??o (et audio si on force un lien)
    category: "", // si tu veux permettre de changer
    file: null, // pour remplacer un audio
    videoFile: null, // pour remplacer une science video
    workbookFile: null, // pour remplacer un workbook pdf
    removeWorkbook: false,
    removeVideo: false,
  });
  const [savingEdit, setSavingEdit] = useState(false);
  const [scienceVideos, setScienceVideos] = useState([]);
  const [, setLoadingAddSciences] = useState(false);
  const [addVideoCategory, setAddVideoCategory] = useState("meditation");
  const [loadingMeditationList, setLoadingMeditationList] = useState(true);
  const [loadingReflectionList, setLoadingReflectionList] = useState(true);
  const [loadingSciencesList, setLoadingSciencesList] = useState(true);
  const [loadingRetreatDay1List, setLoadingRetreatDay1List] = useState(true);
  const [loadingRetreatDay2List, setLoadingRetreatDay2List] = useState(true);
  const [loadingRetreatDay3List, setLoadingRetreatDay3List] = useState(true);
  const [loadingSimplyStillAngerList, setLoadingSimplyStillAngerList] =
    useState(true);
  const [loadingSimplyStillAnxietyList, setLoadingSimplyStillAnxietyList] =
    useState(true);
  const [loadingSimplyStillGroundingList, setLoadingSimplyStillGroundingList] =
    useState(true);
  const [loadingSimplyStillMorningList, setLoadingSimplyStillMorningList] =
    useState(true);
  const [loadingSimplyStillSadnessList, setLoadingSimplyStillSadnessList] =
    useState(true);
  const [loadingSimplyStillSleepList, setLoadingSimplyStillSleepList] =
    useState(true);
  const [loadingSimplyStillStressList, setLoadingSimplyStillStressList] =
    useState(true);

  const [videoUploading, setVideoUploading] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);

  const mobileAuth = getAuthMobile(mobileApp);

  window.getWebIdToken = async () => {
    const u = getAuth().currentUser;
    if (!u) {
      console.log("pas connect??");
      return;
    }
    console.log(await u.getIdToken(true));
  };

  async function ensureMobileSignedIn() {
    const user = mobileAuth.currentUser;
    if (user) return user;
    // r??cup??rer le token webapp actuel
    const webUser = authWeb.currentUser;
    if (!webUser) throw new Error("Web user not authenticated");
    const webToken = await webUser.getIdToken(true);

    // appeler l'endpoint backend pour obtenir un custom token mobile
    const resp = await fetch(
      `${process.env.REACT_APP_MOBILE_ENDPOINT_BASE}/auth/mobile-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${webToken}`,
        },
      }
    );
    if (!resp.ok) throw new Error("Failed to obtain mobile token");
    const { token } = await resp.json();
    if (!token) throw new Error("No mobile token returned");

    // login mobile project
    return signInWithCustomToken(mobileAuth, token);
  }

  useEffect(() => {
    const qMeditation = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "meditation"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubMeditation = onSnapshot(qMeditation, (snap) => {
      setMeditationVideos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoadingMeditationList(false);
    });

    const qReflection = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "reflection"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubReflection = onSnapshot(qReflection, (snap) => {
      setReflectionVideos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoadingReflectionList(false);
    });

    const qRetreatDay1 = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "meditation_retreat_day1"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubRetreatDay1 = onSnapshot(qRetreatDay1, (snap) => {
      setRetreatDay1Videos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoadingRetreatDay1List(false);
    });

    const qRetreatDay2 = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "meditation_retreat_day2"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubRetreatDay2 = onSnapshot(qRetreatDay2, (snap) => {
      setRetreatDay2Videos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoadingRetreatDay2List(false);
    });

    const qRetreatDay3 = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "meditation_retreat_day3"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubRetreatDay3 = onSnapshot(qRetreatDay3, (snap) => {
      setRetreatDay3Videos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoadingRetreatDay3List(false);
    });

    const qSimplyStillAnger = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "simply_still_anger"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubSimplyStillAnger = onSnapshot(qSimplyStillAnger, (snap) => {
      setSimplyStillAngerVideos(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setLoadingSimplyStillAngerList(false);
    });

    const qSimplyStillAnxiety = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "simply_still_anxiety"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubSimplyStillAnxiety = onSnapshot(qSimplyStillAnxiety, (snap) => {
      setSimplyStillAnxietyVideos(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setLoadingSimplyStillAnxietyList(false);
    });

    const qSimplyStillGrounding = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "simply_still_grounding"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubSimplyStillGrounding = onSnapshot(qSimplyStillGrounding, (snap) => {
      setSimplyStillGroundingVideos(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setLoadingSimplyStillGroundingList(false);
    });

    const qSimplyStillMorning = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "simply_still_morning"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubSimplyStillMorning = onSnapshot(qSimplyStillMorning, (snap) => {
      setSimplyStillMorningVideos(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setLoadingSimplyStillMorningList(false);
    });

    const qSimplyStillSadness = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "simply_still_sadness"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubSimplyStillSadness = onSnapshot(qSimplyStillSadness, (snap) => {
      setSimplyStillSadnessVideos(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setLoadingSimplyStillSadnessList(false);
    });

    const qSimplyStillSleep = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "simply_still_sleep"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubSimplyStillSleep = onSnapshot(qSimplyStillSleep, (snap) => {
      setSimplyStillSleepVideos(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setLoadingSimplyStillSleepList(false);
    });

    const qSimplyStillStress = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "simply_still_stress"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubSimplyStillStress = onSnapshot(qSimplyStillStress, (snap) => {
      setSimplyStillStressVideos(
        snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      );
      setLoadingSimplyStillStressList(false);
    });

    // --- AJOUT ---
    const qScience = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "sciences"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubScience = onSnapshot(qScience, (snap) => {
      setScienceVideos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoadingSciencesList(false);
    });

    // Tous les audios (toutes cat??gories)
    const qAudios = query(
      collection(db, "mobileAppAudioLinks"),
      orderBy("order", "asc"),
      orderBy("createdAt", "asc")
    );
    const unsubAudios = onSnapshot(qAudios, (snap) => {
      setAudioItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoadingAudios(false);
    });

    return () => {
      unsubMeditation();
      unsubReflection();
      unsubAudios();
      unsubScience();
      unsubRetreatDay1();
      unsubRetreatDay2();
      unsubRetreatDay3();
      unsubSimplyStillAnger();
      unsubSimplyStillAnxiety();
      unsubSimplyStillGrounding();
      unsubSimplyStillMorning();
      unsubSimplyStillSadness();
      unsubSimplyStillSleep();
      unsubSimplyStillStress();
    };
  }, []);

  const getYoutubeThumbnail = (url) => {
    try {
      const short = url.match(/youtu\.be\/([^?&]+)/)?.[1];
      if (short) return `https://img.youtube.com/vi/${short}/mqdefault.jpg`;
      const id = url.match(/[?&]v=([^&]+)/)?.[1];
      if (id) return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
      return null;
    } catch {
      return null;
    }
  };

  // rendu vignettes
  const MediaThumb = ({ kind, url, title, thumbUrl }) => {
    const yt =
      kind === "video" ? (url ? getYoutubeThumbnail(url) : null) : null;
    const preferred = kind === "video" && thumbUrl ? thumbUrl : yt;
    return preferred ? (
      <img
        src={preferred}
        alt={title}
        style={{
          width: 72,
          height: 40,
          objectFit: "cover",
          borderRadius: 8,
          border: "1px solid #e5e7eb",
        }}
      />
    ) : (
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          background: "#eef2f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #e5e7eb",
        }}
      >
        {kind === "video" ? (
          <MovieIcon sx={{ color: "#64748b" }} />
        ) : (
          <AudiotrackIcon sx={{ color: "#64748b" }} />
        )}
      </div>
    );
  };

  const MediaRow = ({
    item,
    kind, // 'video' | 'audio'
    idx,
    total,
    onOpen,
    onMoveUp,
    onMoveDown,
    onDelete,
    onEdit,
  }) => {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 1.5,
          mb: 1,
          borderRadius: 2,
          border: "1px solid #e5e7eb",
          "&:hover": { borderColor: "#cbd5e1", backgroundColor: "#fafafa" },
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <MediaThumb
            kind={kind}
            url={item.url}
            title={item.title}
            thumbUrl={item.thumbUrl}
          />

          <Stack sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="subtitle1"
              noWrap
              sx={{ fontWeight: 600, color: "#0b3c4c" }}
              title={item.title}
            >
              {item.title}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip
                size="small"
                label={item.category}
                sx={{ height: 22, fontSize: 12 }}
              />
              {kind === "video" && (
                <Chip
                  size="small"
                  label={item.workbookUrl ? "Workbook ???" : "No Workbook"}
                  sx={{
                    height: 22,
                    fontSize: 12,
                    bgcolor: item.workbookUrl ? "#e8f5e9" : "#f1f5f9",
                    color: item.workbookUrl ? "#2e7d32" : "#64748b",
                  }}
                />
              )}
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                order: {Number(item.order ?? 0)}
              </Typography>
            </Stack>
            {item.description ? (
              <Typography
                variant="body2"
                sx={{ color: "#475569", mt: 0.5 }}
                noWrap
                title={item.description}
              >
                {item.description}
              </Typography>
            ) : null}
          </Stack>

          {/* actions ?? droite */}
          <Stack direction="row" spacing={0.5} alignItems="center">
            {kind === "video" && item.workbookUrl ? (
              <IconButton
                size="small"
                onClick={() => onOpen(item.workbookUrl)}
                title="Open workbook"
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            ) : null}
            <IconButton size="small" onClick={() => onEdit(item, kind)}>
              <EditIcon fontSize="small" />
            </IconButton>
            {/* Ouvrir (vid??o ??? YouTube; audio ??? URL brute) */}
            <IconButton size="small" onClick={() => onOpen(item.url)}>
              <OpenInNewIcon fontSize="small" />
            </IconButton>

            {/* R??ordonner (uniquement pour vid??os) */}
            {kind === "video" && (
              <>
                <IconButton
                  size="small"
                  disabled={idx === 0}
                  onClick={() => onMoveUp(idx)}
                >
                  <ArrowUpwardIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  disabled={idx === total - 1}
                  onClick={() => onMoveDown(idx)}
                >
                  <ArrowDownwardIcon fontSize="small" />
                </IconButton>
              </>
            )}

            {/* Supprimer */}
            <IconButton
              size="small"
              onClick={() => onDelete(item, kind)}
              color="error"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>

        {kind === "audio" && (
          <div style={{ marginTop: 8 }}>
            <audio controls src={item.url} style={{ width: "100%" }} />
          </div>
        )}
      </Paper>
    );
  };

  const nextOrder = (arr) =>
    (arr.reduce((m, v) => Math.max(m, Number(v.order ?? 0)), -1) ?? -1) + 1;

  async function fetchNextAudioOrder(category) {
    const q = query(
      collection(db, "mobileAppAudioLinks"),
      where("category", "==", category),
      orderBy("order", "desc"),
      limit(1)
    );
    const snap = await getDocs(q);
    if (snap.empty) return 0;
    const max = Number(snap.docs[0].data()?.order ?? 0);
    return max + 1;
  }

  const handleAddVideo = async (
    category,
    title,
    urlFromForm,
    file,
    workbookFile
  ) => {
    const isMeditation = category === "meditation";
    const isSciences = category === "sciences";
    const isReflection = category === "reflection";
    try {
      if (isMeditation) setLoadingAddMeditation(true);
      else if (isSciences) setLoadingAddSciences(true);
      else if (isReflection) setLoadingAddReflection(true);

      if (!title.trim()) {
        showCustomToast("Title required", "error");
        return;
      }

      const user = authWeb.currentUser;
      if (!user) {
        showCustomToast("You must be logged in", "error");
        return;
      }
      const idToken = await user.getIdToken(true);

      let url = urlFromForm?.trim() || "";
    let storagePath = null;
    let workbookUrl = null;

      await ensureMobileSignedIn();

    if (file) {
        // const storage = getStorage();           // remplace cett
        const storage = mobileStorage;
        storagePath = `videos/${Date.now()}_${file.name}`;
        const storageRef = ref(storage, storagePath);
        const uploadTask = uploadBytesResumable(storageRef, file);
        setVideoUploading(true);
        setVideoProgress(0);
        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            (snap) =>
              setVideoProgress((snap.bytesTransferred / snap.totalBytes) * 100),
            reject,
            resolve
          );
        });
      url = await getDownloadURL(storageRef);
      setVideoUploading(false);
      setTimeout(() => setVideoProgress(0), 600);
    }

    if (workbookFile) {
      const storage = mobileStorage;
      const workbookPath = `workbooks/${Date.now()}_${workbookFile.name}`;
      const workbookRef = ref(storage, workbookPath);
      const workbookTask = uploadBytesResumable(workbookRef, workbookFile);
      await new Promise((resolve, reject) => {
        workbookTask.on("state_changed", () => {}, reject, resolve);
      });
      workbookUrl = await getDownloadURL(workbookRef);
    }

    if (!url) {
      showCustomToast("Provide a file or a URL", "error");
      return;
    }

      const list = getVideoArrayByCategory(category);
      const order = nextOrder(list);

    const { id: mobileId } = await addMobileVideoLink(
      { title, url, category, order, storagePath, workbookUrl },
      idToken
    );

      const thumbUrl = getYoutubeThumbnail(url) || null;
      await addDoc(collection(db, "mobileAppVideoLinks"), {
        title,
      url,
      category,
      order,
      thumbUrl,
      storagePath,
      workbookUrl,
      mobileId,
      createdAt: serverTimestamp(),
      createdBy: user.email || "unknown",
    });

      showCustomToast("Video added to mobile & web ???", "success");
    } catch (e) {
      console.error(e);
      showCustomToast(`Error adding video: ${e.message}`, "error");
    } finally {
      if (isMeditation) setLoadingAddMeditation(false);
      else if (isSciences) setLoadingAddSciences(false);
      else if (isReflection) setLoadingAddReflection(false);
      setVideoUploading(false);
      setVideoProgress(0);
    }
  };

  // Delete: ouvre le modal
  const askDelete = (webDoc, kind /* 'video' | 'audio' */) => {
    setConfirmTarget({ ...webDoc, _kind: kind });
    setConfirmOpen(true);
  };

  // Delete: confirme
  const confirmDelete = async () => {
    if (!confirmTarget) return;
    try {
      setDeleting(true);
      const user = authWeb.currentUser;
      if (!user) {
        showCustomToast("You must be logged in", "error");
        return;
      }
      const idToken = await user.getIdToken(true);

      if (confirmTarget._kind === "video") {
        if (confirmTarget.mobileId) {
          await deleteMobileVideoLink(confirmTarget.mobileId, idToken);
        }
        try {
          if (confirmTarget.storagePath) {
            const storage = getStorage();
            await deleteObject(ref(storage, confirmTarget.storagePath));
          }
        } catch (err) {
          console.warn("Storage delete failed:", err);
        }
        await deleteDoc(doc(db, "mobileAppVideoLinks", confirmTarget.id));
      } else if (confirmTarget._kind === "audio") {
        if (
          confirmTarget.mobileId &&
          typeof deleteMobileAudioLink === "function"
        ) {
          await deleteMobileAudioLink(confirmTarget.mobileId, idToken);
        }
        try {
          if (confirmTarget.storagePath) {
            const storage = getStorage();
            await deleteObject(ref(storage, confirmTarget.storagePath));
          }
        } catch (err) {
          console.warn("Storage delete failed:", err);
        }
        await deleteDoc(doc(db, "mobileAppAudioLinks", confirmTarget.id));
      }

      showCustomToast(
        confirmTarget._kind === "audio"
          ? "Audio deleted ???"
          : "Video deleted ???",
        "success"
      );
      setConfirmOpen(false);
      setConfirmTarget(null);
    } catch (e) {
      console.error(e);
      showCustomToast(`Error deleting video: ${e.message}`, "error");
    } finally {
      setDeleting(false);
    }
  };

  // Ouvrir la vid??o dans un nouvel onglet
  const openVideo = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // R??ordonner (swap order avec voisin)
  const move = async (arr, index, dir /* -1 up, +1 down */) => {
    const a = arr[index];
    const b = arr[index + dir];
    if (!a || !b) return;

    try {
      const user = authWeb.currentUser;
      if (!user) {
        showCustomToast("You must be logged in", "error");
        return;
      }
      const idToken = await user.getIdToken(true);

      // swap orders
      const orderA = Number(a.order ?? 0);
      const orderB = Number(b.order ?? 0);

      // 1) mobile
      if (a.mobileId) await updateMobileVideoOrder(a.mobileId, orderB, idToken);
      if (b.mobileId) await updateMobileVideoOrder(b.mobileId, orderA, idToken);

      // 2) webapp
      await updateDoc(doc(db, "mobileAppVideoLinks", a.id), { order: orderB });
      await updateDoc(doc(db, "mobileAppVideoLinks", b.id), { order: orderA });

      // pas besoin de setState local : onSnapshot mettra ?? jour
    } catch (e) {
      console.error(e);
      showCustomToast(`Error reordering: ${e.message}`, "error");
    }
  };

  const handleSaveEdit = async () => {
    if (!editTarget) return;
    const user = authWeb.currentUser;
    if (!user) {
      showCustomToast("You must be logged in", "error");
      return;
    }
    const idToken = await user.getIdToken(true);

    if (editTarget._kind === "video") {
      if (editTarget.category === "sciences") {
        await ensureMobileSignedIn();
        let newUrl = editTarget.url;
        let newStoragePath = editTarget.storagePath;
        let newWorkbookUrl = editTarget.workbookUrl || null;

        const oldVideoStoragePath = editTarget.storagePath;
        const oldWorkbookUrl = editTarget.workbookUrl || null;

        if (editValues.videoFile) {
          const storage = mobileStorage;
          const storagePath = `videos/${Date.now()}_${editValues.videoFile.name}`;
          const storageRef = ref(storage, storagePath);
          const uploadTask = uploadBytesResumable(storageRef, editValues.videoFile);
          setVideoUploading(true);
          setVideoProgress(0);
          await new Promise((resolve, reject) => {
            uploadTask.on(
              "state_changed",
              (snap) =>
                setVideoProgress(
                  (snap.bytesTransferred / snap.totalBytes) * 100
                ),
              reject,
              resolve
            );
          });
          newUrl = await getDownloadURL(storageRef);
          newStoragePath = storagePath;
          setVideoUploading(false);
          setTimeout(() => setVideoProgress(0), 600);
        }

        if (editValues.workbookFile) {
          const storage = mobileStorage;
          const workbookPath = `workbooks/${Date.now()}_${editValues.workbookFile.name}`;
          const workbookRef = ref(storage, workbookPath);
          const workbookTask = uploadBytesResumable(workbookRef, editValues.workbookFile);
          await new Promise((resolve, reject) => {
            workbookTask.on("state_changed", () => {}, reject, resolve);
          });
          newWorkbookUrl = await getDownloadURL(workbookRef);
        } else if (editValues.removeWorkbook) {
          newWorkbookUrl = null;
        }

        if (editValues.removeVideo && !editValues.videoFile) {
          newUrl = null;
          newStoragePath = null;
        }

        if (editTarget.mobileId && typeof updateMobileVideoLink === "function") {
          await updateMobileVideoLink(
            editTarget.mobileId,
            {
              title: editValues.title,
              url: newUrl,
              category: editValues.category,
              storagePath: newStoragePath,
              workbookUrl: newWorkbookUrl,
            },
            idToken
          );
        }

        await updateDoc(doc(db, "mobileAppVideoLinks", editTarget.id), {
          title: editValues.title,
          url: newUrl,
          category: editValues.category,
          storagePath: newStoragePath,
          workbookUrl: newWorkbookUrl,
          updatedAt: serverTimestamp(),
          updatedBy: user.email || "unknown",
        });

        // cleanup old video file if replaced or removed
        if (
          (editValues.videoFile || editValues.removeVideo) &&
          oldVideoStoragePath &&
          oldVideoStoragePath !== newStoragePath
        ) {
          try {
            const storage = getStorage();
            await deleteObject(ref(storage, oldVideoStoragePath));
          } catch (err) {
            console.warn("Old video delete failed:", err);
          }
        }

        // cleanup old workbook if replaced or removed
        if ((editValues.workbookFile || editValues.removeWorkbook) && oldWorkbookUrl) {
          try {
            const storage = getStorage();
            const m = oldWorkbookUrl.match(/\/o\/([^?]+)/);
            if (m?.[1]) {
              const decodedPath = decodeURIComponent(m[1]);
              await deleteObject(ref(storage, decodedPath));
            }
          } catch (err) {
            console.warn("Old workbook delete failed:", err);
          }
        }
        showCustomToast("Science video updated ???", "success");
        return;
      }
      // 1) MOBILE
      if (editTarget.mobileId && typeof updateMobileVideoLink === "function") {
        await updateMobileVideoLink(
          editTarget.mobileId,
          {
            title: editValues.title,
            url: editValues.url,
            category: editValues.category,
          },
          idToken
        );
      }
      // 2) WEBAPP
      //    Si l'URL a chang??, on recalcule la miniature
      const newThumbUrl =
        editValues.url && editValues.url !== editTarget.url
          ? getYoutubeThumbnail(editValues.url) || null
          : editTarget.thumbUrl || null;
      await updateDoc(doc(db, "mobileAppVideoLinks", editTarget.id), {
        title: editValues.title,
        url: editValues.url,
        category: editValues.category,
        thumbUrl: newThumbUrl,
        updatedAt: serverTimestamp(),
        updatedBy: user.email || "unknown",
      });
      showCustomToast("Video updated ???", "success");
      return;
    }

    // --- AUDIO ---
    // si cat??gorie change, on peut recalculer order (optionnel)
    let newFields = {
      title: editValues.title,
      description: editValues.description || null,
      category: editValues.category,
    };

    let newUrl = editTarget.url;
    let newStoragePath = editTarget.storagePath;

    // Remplacement du fichier ?
    if (editValues.file) {
      const storage = getStorage();
      const storagePath = `audios/${Date.now()}_${editValues.file.name}`;
      const storageRef = ref(storage, storagePath);
      const uploadTask = uploadBytesResumable(storageRef, editValues.file);
      // setAudioUploading(true);
      // setAudioProgress(0);
      setAddAudioUploading(true);
      setAddAudioProgress(0);
      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          // (snap) =>
          //   setAudioProgress((snap.bytesTransferred / snap.totalBytes) * 100),
          (snap) =>
            setAddAudioProgress(
              (snap.bytesTransferred / snap.totalBytes) * 100
            ),
          reject,
          resolve
        );
      });
      newUrl = await getDownloadURL(storageRef);
      newStoragePath = storagePath;
    }

    // si la cat??gorie change ??? option: recalculer un order ?? la fin du nouveau groupe
    let nextOrderVal = editTarget.order ?? 0;
    if (editValues.category !== editTarget.category) {
      nextOrderVal = await fetchNextAudioOrder(editValues.category);
    }

    // 1) MOBILE
    if (editTarget.mobileId && typeof updateMobileAudioLink === "function") {
      await updateMobileAudioLink(
        editTarget.mobileId,
        {
          ...newFields,
          url: newUrl,
          storagePath: newStoragePath,
          order: nextOrderVal,
        },
        idToken
      );
    }

    // 2) WEBAPP
    await updateDoc(doc(db, "mobileAppAudioLinks", editTarget.id), {
      ...newFields,
      url: newUrl,
      storagePath: newStoragePath,
      order: nextOrderVal,
      updatedAt: serverTimestamp(),
      updatedBy: user.email || "unknown",
    });

    // 3) Optionnel: si on a remplac?? le fichier, supprimer l'ancien Storage
    if (
      editValues.file &&
      editTarget.storagePath &&
      editTarget.storagePath !== newStoragePath
    ) {
      try {
        const storage = getStorage();
        await deleteObject(ref(storage, editTarget.storagePath));
      } catch {}
    }

    setAudioUploading(false);
    setTimeout(() => setAudioProgress(0), 600);
    showCustomToast("Audio updated ???", "success");
  };

  // ??? Fonction utilis??e par la modale "Add Audio"
  const handleUploadAudioFromModal = async ({
    title,
    description,
    category,
    file,
  }) => {
    if (!file) {
      showCustomToast("Audio file required", "error");
      return;
    }
    const user = authWeb.currentUser;
    if (!user) {
      showCustomToast("You must be logged in", "error");
      return;
    }
    if (!title.trim()) {
      showCustomToast("Audio title required", "error");
      return;
    }
    if (!category) {
      showCustomToast("Audio category required", "error");
      return;
    }

    // 1) Upload Storage
    const storage = getStorage();
    const storagePath = `audios/${Date.now()}_${file.name}`;
    const storageRef = ref(storage, storagePath);
    const uploadTask = uploadBytesResumable(storageRef, file);

    setAudioUploading(true);
    setAudioProgress(0);
    await new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snap) =>
          setAudioProgress((snap.bytesTransferred / snap.totalBytes) * 100),
        reject,
        resolve
      );
    });
    const url = await getDownloadURL(storageRef);

    // 2) Order
    const order = await fetchNextAudioOrder(category);

    // 3) API mobile
    const idToken = await user.getIdToken(true);
    const { id: mobileId } = await addMobileAudioLink(
      {
        title,
        description: description || null,
        category,
        url,
        storagePath,
        order,
      },
      idToken
    );

    // 4) Miroir Firestore
    await addDoc(collection(db, "mobileAppAudioLinks"), {
      title,
      description: description || null,
      category,
      order,
      storagePath,
      url,
      mobileId,
      createdAt: serverTimestamp(),
      createdBy: user.email || "unknown",
    });

    showCustomToast("Audio uploaded to mobile & web ???", "success");
    // setAudioUploading(false);
    // setTimeout(() => setAudioProgress(0), 800);
    setAddAudioUploading(false);
    setTimeout(() => setAddAudioProgress(0), 800);
  };

  // --- AJOUT ---
  const getVideoArrayByCategory = (category) => {
    if (category === "meditation") return meditationVideos;
    if (category === "reflection") return reflectionVideos;
    if (category === "sciences") return scienceVideos;
    if (category === "meditation_retreat_day1") return retreatDay1Videos;
    if (category === "meditation_retreat_day2") return retreatDay2Videos;
    if (category === "meditation_retreat_day3") return retreatDay3Videos;
    if (category === "simply_still_anger") return simplyStillAngerVideos;
    if (category === "simply_still_anxiety") return simplyStillAnxietyVideos;
    if (category === "simply_still_grounding") return simplyStillGroundingVideos;
    if (category === "simply_still_morning") return simplyStillMorningVideos;
    if (category === "simply_still_sadness") return simplyStillSadnessVideos;
    if (category === "simply_still_sleep") return simplyStillSleepVideos;
    if (category === "simply_still_stress") return simplyStillStressVideos;
    return [];
  };

  // --- SKELETONS ---
  const VideoRowSkeleton = () => (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mb: 1,
        borderRadius: 2,
        border: "1px solid #e5e7eb",
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Skeleton
          variant="rectangular"
          width={72}
          height={40}
          sx={{ borderRadius: 1 }}
        />
        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="40%" height={20} />
        </Stack>
      </Stack>
    </Paper>
  );

  const renderVideoSkeletons = (count = 3) =>
    Array.from({ length: count }).map((_, i) => (
      <VideoRowSkeleton key={`vsk-${i}`} />
    ));

  const AudioRowSkeleton = () => (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mb: 1,
        borderRadius: 2,
        border: "1px solid #e5e7eb",
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Skeleton
          variant="rectangular"
          width={48}
          height={48}
          sx={{ borderRadius: 2 }}
        />
        <Stack sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="70%" height={24} />
          <Skeleton variant="text" width="50%" height={20} />
          <Skeleton
            variant="rectangular"
            height={8}
            sx={{ mt: 1, borderRadius: 1 }}
          />
        </Stack>
        <Skeleton
          variant="rectangular"
          width={70}
          height={36}
          sx={{ borderRadius: 1 }}
        />
      </Stack>
    </Paper>
  );

  const renderAudioSkeletons = (count = 3) =>
    Array.from({ length: count }).map((_, i) => (
      <AudioRowSkeleton key={`ask-${i}`} />
    ));

  const renderUnifiedList = (items, kind) =>
    items.map((it, idx) => (
      <MediaRow
        key={it.id}
        item={it}
        kind={kind} // 'video' | 'audio'
        idx={idx}
        total={items.length}
        onOpen={openVideo}
        onMoveUp={(i) =>
          move(
            kind === "video" ? getVideoArrayByCategory(it.category) : [],
            i,
            -1
          )
        }
        onMoveDown={(i) =>
          move(
            kind === "video" ? getVideoArrayByCategory(it.category) : [],
            i,
            1
          )
        }
        onDelete={askDelete}
        onEdit={(it, kind) => openEditModal(it, kind)}
      />
    ));
  const openEditModal = (doc, kind) => {
    setEditTarget({ ...doc, _kind: kind });
    setEditValues({
      title: doc.title || "",
      description: doc.description || "",
      url: doc.url || "",
      category: doc.category || "",
      file: null,
      videoFile: null,
      workbookFile: null,
      removeWorkbook: false,
      removeVideo: false,
    });
    if (kind === "video" && doc.category === "sciences") {
      setEditScienceOpen(true);
    } else {
      setEditOpen(true);
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "10px",
        marginTop: "20px",
      }}
    >
      {/* <h2>Manage Meditation & Reflection Videos</h2> */}
      <h2 style={{ fontWeight: 700, letterSpacing: 0.2, marginBottom: 8 }}>
        Media manager
      </h2>
      <div style={{ color: "#64748b", fontSize: 14, marginBottom: 12 }}>
        Add, preview, reorder and delete your media.
      </div>

      <MeditationVideosSection
        videos={meditationVideos}
        loading={loadingMeditationList}
        onAdd={() => {
          setAddVideoCategory("meditation");
          setAddVideoOpen(true);
        }}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
      />

      <ReflectionVideosSection
        videos={reflectionVideos}
        loading={loadingReflectionList}
        onAdd={() => {
          setAddVideoCategory("reflection");
          setAddVideoOpen(true);
        }}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
      />

      <RetreatDayVideosSection
        day1={{ items: retreatDay1Videos, loading: loadingRetreatDay1List }}
        day2={{ items: retreatDay2Videos, loading: loadingRetreatDay2List }}
        day3={{ items: retreatDay3Videos, loading: loadingRetreatDay3List }}
        onAddDay1={() => {
          setAddVideoCategory("meditation_retreat_day1");
          setAddVideoOpen(true);
        }}
        onAddDay2={() => {
          setAddVideoCategory("meditation_retreat_day2");
          setAddVideoOpen(true);
        }}
        onAddDay3={() => {
          setAddVideoCategory("meditation_retreat_day3");
          setAddVideoOpen(true);
        }}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
      />

      <SimplyStillSections
        sections={[
          {
            key: "simply_still_anger",
            title: "Anger",
            items: simplyStillAngerVideos,
            loading: loadingSimplyStillAngerList,
            onAdd: () => {
              setAddVideoCategory("simply_still_anger");
              setAddVideoOpen(true);
            },
            emptyText: "No Anger videos uploaded yet.",
          },
          {
            key: "simply_still_anxiety",
            title: "Anxiety",
            items: simplyStillAnxietyVideos,
            loading: loadingSimplyStillAnxietyList,
            onAdd: () => {
              setAddVideoCategory("simply_still_anxiety");
              setAddVideoOpen(true);
            },
            emptyText: "No Anxiety videos uploaded yet.",
          },
          {
            key: "simply_still_grounding",
            title: "Grounding",
            items: simplyStillGroundingVideos,
            loading: loadingSimplyStillGroundingList,
            onAdd: () => {
              setAddVideoCategory("simply_still_grounding");
              setAddVideoOpen(true);
            },
            emptyText: "No Grounding videos uploaded yet.",
          },
          {
            key: "simply_still_morning",
            title: "Morning",
            items: simplyStillMorningVideos,
            loading: loadingSimplyStillMorningList,
            onAdd: () => {
              setAddVideoCategory("simply_still_morning");
              setAddVideoOpen(true);
            },
            emptyText: "No Morning videos uploaded yet.",
          },
          {
            key: "simply_still_sadness",
            title: "Sadness",
            items: simplyStillSadnessVideos,
            loading: loadingSimplyStillSadnessList,
            onAdd: () => {
              setAddVideoCategory("simply_still_sadness");
              setAddVideoOpen(true);
            },
            emptyText: "No Sadness videos uploaded yet.",
          },
          {
            key: "simply_still_sleep",
            title: "Sleep",
            items: simplyStillSleepVideos,
            loading: loadingSimplyStillSleepList,
            onAdd: () => {
              setAddVideoCategory("simply_still_sleep");
              setAddVideoOpen(true);
            },
            emptyText: "No Sleep videos uploaded yet.",
          },
          {
            key: "simply_still_stress",
            title: "Stress",
            items: simplyStillStressVideos,
            loading: loadingSimplyStillStressList,
            onAdd: () => {
              setAddVideoCategory("simply_still_stress");
              setAddVideoOpen(true);
            },
            emptyText: "No Stress videos uploaded yet.",
          },
        ]}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
      />

      <ScienceVideosSection
        videos={scienceVideos}
        loading={loadingSciencesList}
        onAdd={() => {
          setAddVideoCategory("sciences");
          setAddScienceVideoOpen(true);
        }}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
      />

      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          borderRadius: 2,
          border: "1px solid #dcd6f7",
          background: "#efecff",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Typography variant="h6">Reflection audio files</Typography>
          <Button variant="contained" onClick={() => setAddAudioOpen(true)}>
            Add Audio
          </Button>
        </Stack>
        {loadingAudios ? (
          renderAudioSkeletons(3)
        ) : audioItems.length === 0 ? (
          <Paper
            elevation={0}
            sx={{
              p: 3,
              border: "1px dashed #cbd5e1",
              background: "#fff",
              borderRadius: 2,
              color: "#607d8b",
              textAlign: "center",
            }}
          >
            No audio uploaded yet.
          </Paper>
        ) : (
          renderUnifiedList(audioItems, "audio")
        )}
      </Paper>

      <ConfirmDeleteDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        deleting={deleting}
        confirmTarget={confirmTarget}
        onConfirm={confirmDelete}
      />
      <AddVideoDialog
        open={addVideoOpen}
        onClose={() => setAddVideoOpen(false)}
        values={addVideoValues}
        setValues={setAddVideoValues}
        adding={addingVideo}
        onSubmit={async () => {
          try {
            setAddingVideo(true);
            if (!addVideoValues.url.trim()) {
              showCustomToast("YouTube URL required", "error");
              setAddingVideo(false);
              return;
            }
            await handleAddVideo(
              addVideoCategory,
              addVideoValues.title,
              addVideoValues.url,
              null
            );
            setAddVideoValues({ title: "", url: "", file: null });
            setAddVideoOpen(false);
          } finally {
            setAddingVideo(false);
          }
        }}
      />

      <ScienceVideoDialog
        open={addScienceVideoOpen}
        onClose={() => setAddScienceVideoOpen(false)}
        values={addVideoValues}
        setValues={setAddVideoValues}
        adding={addingVideo}
        uploading={videoUploading}
        progress={videoProgress}
        onSubmit={async () => {
          try {
            setAddingVideo(true);
            if (!addVideoValues.file) {
              showCustomToast("Video file required", "error");
              setAddingVideo(false);
              return;
            }
            await handleAddVideo(
              "sciences",
              addVideoValues.title,
              "",
              addVideoValues.file,
              addVideoValues.workbookFile
            );
            setAddVideoValues({
              title: "",
              url: "",
              file: null,
              workbookFile: null,
            });
            setAddScienceVideoOpen(false);
          } finally {
            setAddingVideo(false);
          }
        }}
      />
      <AddAudioDialog
        open={addAudioOpen}
        onClose={() => setAddAudioOpen(false)}
        addingAudio={addingAudio}
        addAudioValues={addAudioValues}
        setAddAudioValues={setAddAudioValues}
        addAudioUploading={addAudioUploading}
        addAudioProgress={addAudioProgress}
        onSubmit={async () => {
          try {
            setAddingAudio(true);
            await handleUploadAudioFromModal(addAudioValues);
            setAddAudioValues({
              title: "",
              description: "",
              category: "reflection",
              file: null,
            });
            setAddAudioOpen(false);
          } finally {
            setAddingAudio(false);
          }
        }}
      />

      <EditVideoDialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        saving={savingEdit}
        editTarget={editTarget}
        editValues={editValues}
        setEditValues={setEditValues}
        editAudioUploading={editAudioUploading}
        editAudioProgress={editAudioProgress}
        onSave={async () => {
          try {
            setSavingEdit(true);
            await handleSaveEdit();
            setEditOpen(false);
          } finally {
            setSavingEdit(false);
          }
        }}
      />
      <EditScienceDialog
        open={editScienceOpen}
        onClose={() => setEditScienceOpen(false)}
        saving={savingEdit}
        editTarget={editTarget}
        editValues={editValues}
        setEditValues={setEditValues}
        videoUploading={videoUploading}
        videoProgress={videoProgress}
        onCopy={async (value) => {
          try {
            await navigator.clipboard.writeText(value);
            showCustomToast("Link copied", "success");
          } catch {
            showCustomToast("Copy failed", "error");
          }
        }}
        onSave={async () => {
          try {
            setSavingEdit(true);
            await handleSaveEdit();
            setEditScienceOpen(false);
          } finally {
            setSavingEdit(false);
          }
        }}
      />    </div>
  );
}

export default MAVideoLinks;

